export default __webpack_public_path__ + "static/PBrownInterview-c1bcae01a21f71d28a03941335ad43bb.mp3";